<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-filter"
                            placeholder="Emissão"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'E', search: 'Entrada' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.referencia"
                            @input="load()" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-filter"
                            placeholder="Todos..."
                            optionsMode="json"
                            :optionsList="[
                                { id: 'A', search: 'Ativa' },
                                { id: 'L', search: 'Lançada' },
                                { id: 'P', search: 'Processada' },
                                { id: 'C', search: 'Cancelada' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.status"
                            @input="load()" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-warehouse"
                            placeholder="Selecione o Local..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="filtros.id_estoque_local"
                            @input="load()" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2" v-if="lista_enquetes && lista_enquetes.length">
                        <az-input
                            type="select"
                            icon="fa-solid fa-clipboard-check fa-fw"
                            placeholder="Todas..."
                            optionsMode="json"
                            :optionsList="[
                                { id: 'A', search: 'Avaliadas' },
                                { id: 'N', search: 'Não Avaliadas' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.tipo_enquete" />
                    </div>
                    <div class="col col-12" :class="( lista_enquetes && lista_enquetes.length ) ? 'col-md-10' : ''">
                        <az-input
                            icon="fa fa-search"
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" :disabled="!filtros.id_estoque_local" type="button" @click="incluir()" title="Incluir Nota Fiscal">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>

                                    <file-upload
                                        class="btn btn-outline-primary"
                                        post-action="http://52.201.90.35/api/upload_arquivo_atendimento"
                                        extensions="xml"
                                        accept="application/xml"
                                        input-id="file"
                                        name="file"
                                        :headers="{ ...axios.defaults.headers.post }"
                                        :multiple="false"
                                        :size="1024 * 1024 * 10 || 0"
                                        :custom-action="azUpload"
                                        v-model="files"
                                        @input-filter="inputFilter"
                                        @input-file="inputFile"
                                        ref="upload">
                                        <i class="fas fa-file-import" aria-hidden="true" title="Importar Nota Fiscal (XML)"></i>
                                    </file-upload>
                                    <!-- <button class="btn btn-outline-primary" :disabled="!filtros.id_estoque_local" type="button" @click="importarNF()"> -->
                                    <!--     <i class="fas fa-file-import" aria-hidden="true"></i> -->
                                    <!-- </button> -->
                                </div>
                                <print-export printid="lista-impressao" :dados="dados_exportacao" :left="true" />
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state v-if="!lista || !lista.length" icon="fas fa-file-invoice-dollar"
            msg="Nenhuma nota fiscal identificada." />

        <div v-else id="lista-impressao">

            <cabecalho-generico titulo="Compras">
                <div v-if="filtros_busca">
                    <div>{{ $util.filtro_2_periodo(filtros_busca) }}</div>
                    <div v-if="filtros.search">Pesquisa: {{ filtros.search }}</div>
                </div>
            </cabecalho-generico>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(nota, inx) in lista" :key="inx">
                <div class="card-body py-2" :class="!nota.fl_ativo ? 'alert-secondary' : ''">
                    <div class="row" >
                        <div class="col col-12 col-md-2 d-flex align-items-center">
                            <span>
                                <template v-if="nota.fl_processada || nota.st_tipo == 'SF'">
                                    <a href="#" :key="'view' + inx" @click.prevent="editar(nota)" class="btn btn-sm btn-outline-primary mr-1" data-toggle="tooltip" data-placement="top" title="Visualizar">
                                        <i class="fas fa-search fa-fw"></i>
                                    </a>
                                    <template v-if="nota.lancamentos && nota.lancamentos.length">
                                        <a href="#" :key="'finan-checked'" class="btn btn-sm btn-outline-success mr-1" data-toggle="tooltip" data-placement="top" title="Lançamento no financeiro gerado."
                                            @click.prevent="abrir_lancamentos(nota)">
                                            <i class="fas fa-check-circle fa-fw"></i>
                                        </a>
                                    </template>
                                    <template v-else-if="nota.st_tipo != 'SR' && nota.st_tipo != 'BN' && nota.st_tipo != 'ND'">
                                        <a href="#" :key="'finan' + inx" @click.prevent="financeiro(nota)" class="btn btn-sm btn-outline-success mr-1" data-toggle="tooltip" data-placement="top" title="Financeiro">
                                            <i class="fas fa-dollar-sign fa-fw"></i>
                                        </a>
                                    </template>
                                </template>
                                <template v-else-if="nota.fl_ativo">
                                    <a href="#" :key="'edit' + inx" @click.prevent="editar(nota)" class="btn btn-sm btn-outline-primary mr-1" data-toggle="tooltip" data-placement="top" title="Editar">
                                        <i class="fas fa-edit fa-fw"></i>
                                    </a>
                                    <a href="#" :key="'mov' + inx" @click.prevent="movimentar(nota)" class="btn btn-sm btn-outline-success mr-1" data-toggle="tooltip" data-placement="top" title="Realizar Movimentação">
                                        <i class="fas fa-sign-in-alt fa-fw"></i>
                                    </a>
                                </template>
                                <template v-else-if="!nota.fl_ativo">
                                    <a href="#" :key="'edit' + inx" @click.prevent="editar(nota)" class="btn btn-sm btn-outline-primary mr-1" data-toggle="tooltip" data-placement="top" title="Editar">
                                        <i class="fas fa-search fa-fw"></i>
                                    </a>
                                </template>
                                <template v-if="nota.fl_processada && nota.st_tipo != 'ND' && tem_item_com_estoque_lote(nota)">
                                    <a href="#" :key="'edit-tag' + inx" @click.prevent="emitir_etiqueta(nota)" class="btn btn-sm btn-outline-primary mr-1" data-toggle="tooltip" data-placement="top" title="Imprimir etiquetas">
                                        <i class="fas fa-tags fa-fw"></i>
                                    </a>
                                </template>
                                <template v-if="lista_enquetes && lista_enquetes.length">
                                    <a href="#" @click.prevent="preencher_enquente(nota)" 
                                        class="btn btn-sm mr-1" 
                                        :class="nota.enquetes_aplicadas_count > 0 ? 'btn-dark' : 'btn-outline-dark'"
                                        title="Avaliação de Fornecedor">
                                        <i class="fa-solid fa-clipboard-check"></i>
                                        <span v-if="nota.enquetes_aplicadas_count" class="badge badge-light ml-1">
                                            {{ nota.enquetes_aplicadas_count }}
                                        </span>
                                    </a>
                                </template>
                            </span>
                        </div>
                        <div class="col col-12 col-md-2 d-flex flex-column justify-content-center">
                            <small v-if="nota.estoque_local">
                                {{ nota.estoque_local.search }}
                            </small>
                            <div>
                                <i class="fas fa-check-circle text-success mr-1" v-if="nota.fl_ativo && nota.fl_processada"></i>
                                <i class="fas fa-times-circle text-danger mr-1" v-if="!nota.fl_ativo"></i>
                                {{ nota.st_serie }}.{{ nota.st_numero }}

                                <span class="badge badge-secondary ml-2" v-if="nota.st_tipo" :title="nota.tipo">
                                    {{ nota.st_tipo }}
                                </span>

                                <a href="#" @click.prevent="abrir_anexar_arquivo(nota)" class="ml-2 card-link">
                                    <i class="fa fa-plus" aria-hidden="true" v-if="!nota.arquivos.length"></i>
                                    <div class="spinner-border spinner-border-sm" role="status" v-else-if="nota.carregando">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <i class="fa fa-paperclip" aria-hidden="true" v-else></i>
                                </a>
                            </div>
                        </div>
                        <div class="col col-12 col-md-2">
                            <div>
                                <small>
                                    Emissão: {{ $util.getFormatDate(nota.dt_emissao) }}
                                </small>
                            </div>
                            <div>
                                <small>
                                    Entrada: {{ $util.getFormatDate(nota.dt_entrada) }}
                                </small>
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div v-if="nota.fornecedor">
                                {{ nota.fornecedor.st_nome_fantasia }}
                                <span v-if="nota.st_observacoes" class="ml-3 small text-muted">
                                    {{ nota.st_observacoes }}
                                </span>
                            </div>
                            <div class="text-nowrap text-truncate">
                                <span class="badge badge-secondary mr-2">{{ nota.items.length }}</span>
                                <small>{{ nota.materiais }}</small>
                            </div>
                        </div>
                        <div class="col col-12 col-md-2 text-right">
                            {{ $util.formatMoeda(nota.dc_valor_nota) }}
                            <div v-if="nota.fornecedor.dc_valor_minimo && nota.fornecedor.dc_valor_minimo > nota.dc_valor_nota" class="text-danger small"
                                title="Faturamento mínimo não atingido">
                                {{ $util.formatMoeda(nota.fornecedor.dc_valor_minimo) }}
                                <i class="fas fa-exclamation-triangle ml-2"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal DePara de  Nota Fiscal -->
        <div class="modal fade" id="notaFiscalDeParaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Identificar Itens da Nota Fiscal</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!itemNF">
                            <az-empty-state msg="Aguarde..." />
                        </template>

                        <template v-if="itemNF">

                            <!--- Tipo de Nota -->

                            <div class="mb-3">

                                <div class="form-row">
                                    <div class="col col-12">
                                        <az-input
                                            sizing="sm"
                                            label="Tipo"
                                            type="select"
                                            placeholder="Padrão" 
                                            :optionsList="[
                                                { id: 'SR', search: 'Simples Remessa' }, 
                                                { id: 'BN', search: 'Bonificação' }, 
                                                { id: 'SF', search: 'Simples Faturamento' }, 
                                                { id: 'ND', search: 'Devolução' }, 
                                            ]"
                                            optionsData="id"
                                            :validate="validate"
                                            v-model="itemNF.st_tipo" />
                                    </div>
                                </div>

                                <div class="form-row mt-1" v-if="( itemNF.st_tipo == 'SR' || itemNF.st_tipo == 'SF' || itemNF.st_tipo == 'ND' )">
                                    <div class="col col-12">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Consignado"
                                            v-model="itemNF.fl_consig" />
                                    </div>
                                </div>

                            </div>

                            <!--- Itens Identificados -->

                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Lote</th>
                                        <th>NCM</th>
                                        <th>Material</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(mat, icx) in itemNF.items" >
                                        <tr v-if="1 == 1 || mat.deParaItem" :key="icx" >
                                            <td :colspan="(mat.item && mat.item.fl_controla_lote) ? 1 : 2">
                                                <az-input   
                                                    type="label"
                                                    sizing="sm"
                                                    :label="mat.deParaItem.descricao" />
                                            </td>
                                            <td width="10%" v-if="mat.item && mat.item.fl_controla_lote">
                                                <az-input   
                                                    sizing="sm"
                                                    v-model="mat.st_lote" />
                                            </td>
                                            <td>
                                                <span v-if="mat.deParaItem">{{ mat.deParaItem.st_ncm }}</span>
                                            </td>
                                            <td width="50%">
                                                <az-input
                                                    placeholder="Selecione o material..."
                                                    sizing="sm"
                                                    type="autocomplete" 
                                                    optionsMode="aql"
                                                    service="estoque_items.index"
                                                    :optionsSync="false"
                                                    optionsName="estoque_items.index"
                                                    v-model="mat.item" />
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </template>

                        <br><br><br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer d-flex justify-content-end" v-if="itemNF">
                        <div>
                            <button type="button" class="btn btn-secondary ml-1" data-dismiss="modal">Fechar</button>
                            <az-submit class="ml-1" @click="atualizarDePara()" >Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal de Nota Fiscal -->
        <div class="modal fade" id="notaFiscalEstoqueModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">Lançamento de Nota Fiscal
                            <span v-if="item && !item.id_estoque_nota_fiscal">
                                (Nova)
                            </span>
                            <span v-else-if="item">
                                #{{ item.id_estoque_nota_fiscal }}
                            </span>
                            <span class="badge badge-danger ml-3" v-if="item && item.id_estoque_nota_fiscal && !item.fl_ativo">
                                Cancelada
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!item">
                            <az-empty-state msg="Aguarde..." />
                        </template>

                        <template v-if="item">
                            <div id="espelho-nota" class="d-none d-print-block">
                                <cabecalho-generico titulo="Espelho da Nota Fiscal">
                                    <div>
                                        <div>Id: #{{ item.id_estoque_nota_fiscal }}</div>
                                    </div>
                                </cabecalho-generico>

                                <div class="form-row">
                                    <div class="col col-12 col-md-6">
                                        Fornecedor: <span v-if="item.fornecedor">{{ item.fornecedor.search }}</span>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <span v-if="item.st_tipo">
                                            Tipo: {{ item.st_tipo }}
                                        </span>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        Número: {{ item.st_serie }}.{{ item.st_numero }}
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-3">
                                        Emissão: {{ $util.getFormatDate(item.dt_emissao) }}
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        Entrada: {{ $util.getFormatDate(item.dt_entrada) }}
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        Desconto: {{ $util.formatMoeda(item.dc_valor_desconto) }}
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        Outras Despesas: {{ $util.formatMoeda(item.dc_outras_despesas) }}
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        Valor: {{ $util.formatMoeda(item.dc_valor_nota) }}
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col col-12 col-md-3">
                                        Local: <span v-if="item.estoque_local">{{ item.estoque_local.search }}</span>
                                    </div>
                                    <div class="col col-12 col-md-9">
                                        Obs: {{ item.st_observacoes }}
                                    </div>
                                </div>
                                <!-- Frete -->
                                <div class="form-row" v-if="item.st_tipo != 'SF' && item.st_tipo != 'ND'">
                                    <div class="col col-12 col-md-2">
                                        Frete: {{ item.st_frete_tipo}}
                                    </div>
                                    <template v-if="( item.st_frete_tipo && item.st_frete_tipo == 'CIF' )">
                                        Valor: {{ $util.formatMoeda(item.dc_frete_valor) }}
                                    </template>
                                    <template v-else-if="( item.st_frete_tipo && item.st_frete_tipo == 'FOB' )">
                                        <div class="col col-12 col-md-4">
                                            Transportador: {{ item.id_frete_fornecedor}}
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            Valor: {{ $util.formatMoeda(item.dc_frete_valor) }}
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            Conhecimento: {{ item.st_frete_conhecimento }}
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            Data: {{ $util.getFormatDate(item.dt_frete_conhecimento) }}
                                        </div>
                                    </template>

                                </div>

                                <!-- @ITEMS -->
                                <az-sub-title class="mt-3" title="Composição">
                                    <span class="mr-2">{{ $util.formatMoeda(totalizar_items(item)) }}</span>
                                    <span>
                                        / {{ lista_items(item).length }}
                                    </span>
                                </az-sub-title>

                                <template>
                                    <table class="table table-sm">
                                        <thead v-if="lista_items(item).length">
                                            <tr>
                                                <th>Item</th>
                                                <th>Lote</th>
                                                <th>Validade</th>
                                                <th class="text-right">Qtd</th>
                                                <th class="text-right">Vl. Unit.</th>
                                                <th class="text-right">Valor</th>
                                                <th class="text-right">IPI</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(comp, icx) in lista_items(item)" :key="icx">
                                                <td :width="comp.item.fl_controla_lote ? '33%' : '53%'" :colspan="comp.item.fl_controla_lote ? 1 : 3">
                                                    {{ comp.item.search }}
                                                    <span class="text-muted ml-2">#{{ comp.item.id_estoque_item }}</span>
                                                </td>
                                                <template v-if="comp.item.fl_controla_lote">
                                                    <td width="10%">
                                                        {{ comp.st_lote }}
                                                    </td>
                                                    <td width="10%">
                                                        {{ comp.dt_validade }}
                                                    </td>
                                                </template>
                                                <td width="10%" class="text-right">
                                                    {{ comp.dc_quantidade }}
                                                </td>
                                                <td width="12%" class="text-right">
                                                    {{ $util.formatMoeda(comp.dc_valor_unitario) }}
                                                </td>
                                                <td width="10%" class="text-right">
                                                    {{ $util.formatMoeda(comp.dc_quantidade * comp.dc_valor_unitario) }}
                                                </td>
                                                <td width="15%" class="text-right">
                                                    {{ $util.formatMoeda(comp.dc_valor_ipi) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Fornecedor"
                                        required
                                        :edicao="!tem_oc"
                                        :validate="validate"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="fornecedores.index"
                                        optionsData="id_fornecedor"
                                        optionsDisplay="search"
                                        v-model="item.id_fornecedor">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                                    data-toggle="tooltip" data-placement="top" title="Incluir Fornecedor"
                                                    @click="incluir_fornecedor()">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        v-if="!item.id_estoque_nota_fiscal || item.st_tipo"
                                        sizing="sm"
                                        label="Tipo"
                                        type="select"
                                        placeholder="Padrão" 
                                        :optionsList="[
                                            { id: 'SR', search: 'Simples Remessa' }, 
                                            { id: 'BN', search: 'Bonificação' }, 
                                            { id: 'SF', search: 'Simples Faturamento' }, 
                                            { id: 'ND', search: 'Devolução' }, 
                                        ]"
                                        optionsData="id"
                                        :edicao="!item.id_estoque_nota_fiscal"
                                        :validate="validate"
                                        v-model="item.st_tipo" />

                                    <az-input
                                        v-else
                                        sizing="sm"
                                        label="Tipo"
                                        :edicao="false"
                                        value="Padrão" />
                                </div>
                                <div class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        label="Série"
                                        required
                                        :validate="validate"
                                        v-model="item.st_serie" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Número"
                                        required
                                        :validate="validate"
                                        v-model="item.st_numero" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="date"
                                        sizing="sm"
                                        label="Data de Emissão"
                                        required
                                        :validate="validate"
                                        v-model="item.dt_emissao" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="date"
                                        sizing="sm"
                                        label="Data de Entrada"
                                        required
                                        :validate="validate"
                                        v-model="item.dt_entrada" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Valor de Desconto"
                                        type="money"
                                        sizing="sm"
                                        :validate="validate"
                                        v-model="item.dc_valor_desconto" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Outras Despesas Acessórias"
                                        type="money"
                                        sizing="sm"
                                        :validate="validate"
                                        v-model="item.dc_outras_despesas" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="Valor da Nota"
                                        type="money"
                                        sizing="sm"
                                        :validate="validate"
                                        v-model="item.dc_valor_nota" />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Local de Armazenagem"
                                        placeholder="Selecione o Local..."
                                        type="select"
                                        service="estoque_locals.index"
                                        optionsData="id_estoque_local"
                                        optionsMode="aql"
                                        required
                                        :validate="validate"
                                        v-model="item.id_estoque_local" />
                                </div>
                                <div class="col col-12 col-md-9">
                                    <az-input
                                        sizing="sm"
                                        label="Observação"
                                        v-model="item.st_observacoes" />
                                </div>
                            </div>
                            <!-- Frete -->
                            <div class="form-row" v-if="item.st_tipo != 'SF' && item.st_tipo != 'ND'">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Frete"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="[
                                            { id: 'N', search: 'Nenhum' },
                                            { id: 'CIF', search: 'CIF' },
                                            { id: 'FOB', search: 'FOB' },
                                        ]"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        required
                                        :validate="validate"
                                        v-model="item.st_frete_tipo" />
                                </div>
                                <template v-if="( item.st_frete_tipo && item.st_frete_tipo == 'CIF' )">
                                    <az-input
                                        label="Valor do Frete"
                                        type="money"
                                        sizing="sm"
                                        required
                                        :validate="validate"
                                        v-model="item.dc_frete_valor" />
                                </template>
                                <template v-else-if="( item.st_frete_tipo && item.st_frete_tipo == 'FOB' )">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            label="Transportador"
                                            required
                                            :validate="validate"
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="fornecedores.index"
                                            optionsData="id_fornecedor"
                                            optionsDisplay="search"
                                            v-model="item.id_frete_fornecedor" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            label="Valor do Frete"
                                            type="money"
                                            sizing="sm"
                                            required
                                            :validate="validate"
                                            v-model="item.dc_frete_valor" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            label="Conhecimento"
                                            sizing="sm"
                                            v-model="item.st_frete_conhecimento" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            label="Data"
                                            type="date"
                                            sizing="sm"
                                            v-model="item.dt_frete_conhecimento" />
                                    </div>
                                </template>

                            </div>

                            <div class="form-row mt-3" v-if="!item.id_estoque_nota_fiscal && item.st_tipo != 'SF' && item.st_tipo != 'ND'">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Consumo Direto"
                                        v-model="item.fl_aplicacao_direta" />
                                </div>
                                <template v-if="item.fl_aplicacao_direta">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            type="select"
                                            placeholder="Centro de Custo..."
                                            :optionsList="lista_centros"
                                            optionsData="id_centro_custo"
                                            required
                                            :validate="validate"
                                            v-model="item.id_centro_custo" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <label class="form form-control form-control-sm alert-warning">
                                            Nota fiscal com movimentação de consumo automática.
                                        </label>
                                    </div>
                                </template>
                            </div>

                            <div v-else-if="item.fl_aplicacao_direta">
                                <label class="form form-control form-control-sm alert-warning mt-3">
                                    Consumo Direto:
                                    <span v-if="item.centro_custo">{{ item.centro_custo.search }}</span>
                                </label>
                            </div>

                            <div class="form-row mt-1" v-if="( item.st_tipo == 'SR' || item.st_tipo == 'SF' || item.st_tipo == 'ND' )">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Consignado"
                                        :edicao="!lista_items(item).length"
                                        v-model="item.fl_consig" />
                                </div>
                            </div>

                            <!-- @ITEMS -->
                            <az-sub-title class="mt-3" title="Composição">
                                <span class="mr-2">{{ $util.formatMoeda(totalizar_items(item)) }}</span>
                                <span class="badge badge-secondary">
                                    {{ lista_items(item).length }}
                                </span>
                            </az-sub-title>

                            <template>
                                <table class="table table-sm">
                                    <thead v-if="lista_items(item).length">
                                        <tr>
                                            <th>Item</th>
                                            <th>Lote</th>
                                            <th>Validade</th>
                                            <th>Qtd</th>
                                            <th>Vl. Unit.</th>
                                            <th class="text-right">Valor</th>
                                            <th>IPI</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(comp, icx) in lista_items(item)" :key="icx">
                                            <td :width="comp.item.fl_controla_lote ? '33%' : '53%'" :colspan="comp.item.fl_controla_lote ? 1 : 3">
                                                <div class="input-group input-group-sm mb-0">
                                                    <div class="input-group-prepend">
                                                        <div class="dropdown">
                                                            <button class="btn btn-outline-secondary btn-sm px-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="!item.fl_processada">
                                                                <i class="fas fa-ellipsis-v"></i>
                                                            </button>
                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" href="#" @click="remover_item(comp)">Remover</a>
                                                                <a class="dropdown-item" href="#" @click="adicionar_lote(comp, icx)" v-if="comp.item.fl_controla_lote">Adicionar Lote</a>
                                                                <template v-if="!comp.id_estoque_nota_fiscal_item">
                                                                    <div class="dropdown-divider"></div>
                                                                    <a class="dropdown-item" href="#" @click.prevent="set_barcode(comp)">Definir Código de Barras</a>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <label class="form-control text-nowrap text-truncate">
                                                        <small>{{ comp.item.search }}</small>
                                                        <small class="text-muted ml-2">#{{ comp.item.id_estoque_item }}</small>
                                                    </label>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary btn-sm px-1" type="button" v-if="!item.fl_processada && !comp.st_marca && !comp.st_observacoes" @click="comp.obs = !comp.obs">
                                                            <i class="fa-solid fa-comment fa-fw" v-if="comp.obs"></i>
                                                            <i class="fa-solid fa-comment-slash fa-fw" v-else></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div v-if="!comp.id_estoque_nota_fiscal_item && comp.add_barcode">
                                                    <az-input 
                                                        class="ml-2 my-1"
                                                        sizing="sm"
                                                        icon="fa-solid fa-barcode"
                                                        placeholder="Informe o código de barras para inclusão..."
                                                        v-model="comp.barcode" />
                                                </div>
                                                <div v-if="comp.obs">
                                                    <div class="form-row ml-2 my-1">
                                                        <div class="col col-12 col-md-4">
                                                            <az-input 
                                                                label="Marca"
                                                                :compact="true"
                                                                sizing="sm"
                                                                placeholder="Marca..."
                                                                v-model="comp.st_marca" />
                                                        </div>
                                                        <div class="col col-12 col-md-8">
                                                            <az-input 
                                                                label="Obs."
                                                                :compact="true"
                                                                sizing="sm"
                                                                placeholder="Observações..."
                                                                v-model="comp.st_observacoes" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <template v-if="comp.item.fl_controla_lote">
                                                <td width="10%">
                                                    <az-input
                                                        sizing="sm"
                                                        type="text"
                                                        required
                                                        :validate="validate"
                                                        v-model="comp.st_lote" />
                                                </td>
                                                <td width="10%">
                                                    <az-input
                                                        sizing="sm"
                                                        type="date"
                                                        required
                                                        :validate="validate"
                                                        :rules="['futuro']"
                                                        v-model="comp.dt_validade" />
                                                </td>
                                            </template>
                                            <td width="10%">
                                                <az-input
                                                    sizing="sm"
                                                    type="number"
                                                    required
                                                    :validate="validate"
                                                    v-model="comp.dc_quantidade">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="comp.item && comp.item.fl_fracionado">
                                                            <span class="input-group-text" id="basic-addon2">{{ comp.item.st_unidade_compra }}</span>
                                                        </div>
                                                        <div class="input-group-append" v-else-if="( comp.in_fator || comp.in_fator === 0 ) && comp.in_fator != 1">
                                                            <span class="input-group-text" id="basic-addon2">x{{ comp.in_fator }}</span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </td>
                                            <td width="12%">
                                                <az-input
                                                    :key="'valor' + icx"
                                                    sizing="sm"
                                                    :type="trocando ? 'number' : 'money'"
                                                    :precision="6"
                                                    :validate="validate"
                                                    v-model="comp.dc_valor_unitario" />
                                            </td>
                                            <td width="10%" class="text-right small">
                                                <az-input
                                                    sizing="sm"
                                                    type="label"
                                                    :label="$util.formatMoeda(comp.dc_quantidade * comp.dc_valor_unitario)">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button type="button" class="btn btn-outline-secondary" @click="informar_valor_total(comp)">
                                                                <i class="fa fa-calculator" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>

                                            </td>
                                            <td width="15%">
                                                <az-input
                                                    sizing="sm"
                                                    :type="trocando ? 'number' : 'money'"
                                                    v-model="comp.dc_valor_ipi" />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colspan="7">
                                                <span class="d-print-none d-block">
                                                    <selecao-material @selecionado="incluir_item" :entrada="true" :infoqt="true" :infopreco="true" :nf="true" />
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>

                            <template v-if="oc">
                                <az-sub-title class="mt-3" title="Ordem de Compra">
                                    <a href="#" @click.prevent="imprimir_oc(oc.id_aquisicao_ordem_compra)">
                                        <span>{{ oc.fornecedor.search }}</span>
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        <span>#{{ oc.id_aquisicao_ordem_compra }}</span>
                                    </a>
                                </az-sub-title>

                                <div>
                                    <a href="#" @click.prevent="toggle_itens_oc(oc)" class="card-link">Todos</a>
                                </div>

                                <div v-for="(oci, iox) in oc.items" :key="iox">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        :label="oci.preco.item.search + ' / ' + oci.preco.search_comp"
                                        :edicao=" oci.qtde_pendente > 0 "
                                        v-model="oci.preco.selec">
                                        <template v-slot:buttonposcb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon1">Qtd: {{ oci.qtde_pendente }} / {{ oci.dc_quantidade }}</span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <button type="button" class="btn btn-primary btn-sm my-3" @click="incluir_oc()">
                                    Incluir Selecionados
                                </button>
                            </template>

                            <div v-if="lista_ocs && lista_ocs.length">
                                <div class="card" v-for="(ocid, iox) in lista_ocs" :key="iox">
                                    <div class="card-header alert-info">
                                        OC:
                                        <a href="#" @click.prevent="imprimir_oc(ocid.id_aquisicao_ordem_compra)" class="card-link">
                                            #{{ ocid.id_aquisicao_ordem_compra }}
                                        </a>
                                    </div>
                                    <ul class="list-group" v-if="ocid && ocid.items && ocid.items.length">
                                        <li class="list-group-item d-flex justify-content-between" v-for="(item, index) in ocid.items" :key="index">
                                            <template v-if="item.preco && item.preco.item && item.preco.item.estoque_item">
                                                <span>
                                                    {{ item.preco.item.estoque_item.search }}
                                                    <span class="badge badge-secondary ml-2">
                                                        #{{ item.preco.item.estoque_item.id_estoque_item }}
                                                    </span>
                                                </span>
                                                <span>
                                                    x{{ item.dc_quantidade }}
                                                </span>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <p v-if="ocs && !ocs.length">
                                Nenhuma OC encontrada.
                            </p>

                            <ul class="list-group mt-3" v-if="ocs && ocs.length && ocs.find(oci => oci.id_fornecedor == item.id_fornecedor)">
                                <li class="list-group-item" v-for="(aoc, iax) in ocs" :key="iax">
                                    <a href="#" @click.prevent="ident_oc = aoc.id_aquisicao_ordem_compra; buscar_oc();">
                                        #{{ aoc.id_aquisicao_ordem_compra }}
                                    </a>
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    <span class="small text-muted">{{ aoc.lista_items }}</span>
                                </li>
                            </ul>

                            <pre v-if="1 == 0 && ocs && ocs.length">{{ ocs }}</pre>

                            <pre v-if="false">{{ item }}</pre>

                            <br><br><br><br><br><br>

                        </template>

                    </div>
                    <div class="modal-footer d-flex justify-content-between" v-if="item">
                        <div>
                            <az-input
                                placeholder="Informe..."
                                v-model="ident_oc">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">OC</span>
                                    </div>
                                </template>
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <az-submit color="outline-secondary" :disabled="!ident_oc && !item.id_fornecedor" @click="buscar_oc()">
                                            <i class="fas fa-sync"></i>
                                        </az-submit>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div>
                            <button type="button" class="btn btn-outline-secondary mr-1" @click="imprimir_espelho()" v-if="item.fl_ativo && item.fl_processada">
                                <i class="fa fa-print" aria-hidden="true"></i>
                            </button>
                            <az-audit-log-button model="estoqueNotaFiscal" :id="item.id_estoque_nota_fiscal" v-if="item.id_estoque_nota_fiscal" />
                            <az-submit class="ml-1" @click="movimentar(item, true)" v-if="item.fl_processada && ( !item.lancamentos || !item.lancamentos.length )" color="danger">Cancelar Processamento</az-submit>
                            <az-submit class="ml-1" @click="cancelar_nota(item)" v-if="item.id_estoque_nota_fiscal && item.fl_ativo && !item.fl_processada" color="danger">Cancelar Nota</az-submit>
                            <button type="button" class="btn btn-secondary ml-1" data-dismiss="modal">Fechar</button>
                            <az-submit class="ml-1" @click="atualizar()" v-if="item.fl_ativo && !item.fl_processada">{{ item.id_estoque_nota_fiscal ? 'Atualizar' : 'Incluir' }}</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Lançamentos -->
        <div class="modal fade" id="lancamentosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="nota_lancamentos">
                    <div class="modal-header">
                        <h5 class="modal-title">Lançamentos Gerados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-info">
                            {{ nota_lancamentos.st_serie }}.{{ nota_lancamentos.st_numero }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            {{ nota_lancamentos.fornecedor.search }}
                        </p>
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <td>Id</td>
                                    <td>Vencimento</td>
                                    <td>Status</td>
                                    <td>Descrição</td>
                                    <td class="text-right">Valor</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(lancamento, ilx) in nota_lancamentos.lancamentos" :key="ilx">
                                    <td>
                                        <a href="#" @click.prevent="editar_lancamento(lancamento)" v-if="lancamento.ch_estado == 'E'">
                                            #{{ lancamento.id_lancamento }}
                                        </a>
                                        <span v-else>
                                            #{{ lancamento.id_lancamento }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ lancamento.vencimento }}
                                    </td>
                                    <td>
                                        {{ lancamento.estado }}
                                    </td>
                                    <td>
                                        <span class="small">
                                            {{ lancamento.st_descricao }}
                                        </span>
                                    </td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(lancamento.dc_valor) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <pre v-if="false">{{ nota_lancamentos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Informar Valor Total -->
        <div class="modal fade" id="informarValorTotalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Valor Total</h5>
                        <button type="button" class="close" @click="fechar_modal('informarValorTotalModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="comp_edicao">
                        <az-input
                            sizing="sm"
                            label="Valor Total"
                            type="money"
                            v-model="valor_total_informado"
                            @onEnter="atualizar_valor_total()" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('informarValorTotalModal')">Close</button>
                        <button type="button" class="btn btn-success" @click="atualizar_valor_total()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Inclusão de Lançamentos no Financeiro -->
        <div class="modal fade" id="incluirLancamentosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="nota_lancamentos">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar Lançamentos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>{{ nota_lancamentos.fornecedor.search }}</div>
                            <div>
                                Valor Total: {{ $util.formatMoeda(nota_lancamentos.valor_sem_frete) }}
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Parcelas"
                                    type="number"
                                    :edicao="false"
                                    v-model="nota_lancamentos.parcelas">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-success" type="button" id="button-addon2" @click="incluir_parcela()">
                                                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                            </button>
                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_parcela()">
                                                <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Total das Parcelas"
                                    :edicao="false"
                                    :value="$util.formatMoeda(total_lista(parcelas, 'dc_valor'))" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <template v-if="!nota_lancamentos.mult_categ">
                                    <az-input
                                        sizing="sm"
                                        label="Categoria"
                                        required
                                        :validate="validate"
                                        type="select"
                                        optionsMode="aql"
                                        service="categorias.index"
                                        :optionsName="'categorias.D'"
                                        optionsData="id_categoria"
                                        optionsDisplay="search"
                                        :optionsParm="{ lancamento: true, where: { ch_natureza: 'D' } }"
                                        v-model="nota_lancamentos.id_categoria" />
                                </template>

                                <template v-else>
                                    <az-input
                                        sizing="sm"
                                        label="Categorias"
                                        :edicao="false"
                                        v-model="nota_lancamentos.categs" />
                                </template>
                            </div>

                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Forma de Pagamento"
                                    :validate="validate"
                                    type="select"
                                    optionsMode="aql"
                                    service="forma_pagamentos.index"
                                    optionsData="id_forma_pagamento"
                                    optionsDisplay="search"
                                    required
                                    v-model="nota_lancamentos.id_forma_pagamento" />
                            </div>
                        </div>

                        <template v-if="!alterando_valores">

                            <div class="form-row" v-for="(parcela, ipx) in parcelas" :key="ipx">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Vencimento"
                                        type="date"
                                        required
                                        :validate="validate"
                                        v-model="parcela.dt_vencimento" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Valor"
                                        type="money"
                                        required
                                        :validate="validate"
                                        v-model="parcela.dc_valor" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Observação"
                                        v-model="parcela.st_observacoes" />
                                </div>
                            </div>

                        </template>

                        <template v-if="nota_lancamentos.id_fornecedor != nota_lancamentos.id_frete_fornecedor && nota_lancamentos.st_frete_tipo == 'FOB' && nota_lancamentos.dc_frete_valor > 0">

                            <hr>

                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Valor do Frete"
                                        sizing="sm"
                                        :edicao="false"
                                        :value="$util.formatMoeda(nota_lancamentos.dc_frete_valor)" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Vencimento do Frete"
                                        type="date"
                                        sizing="sm"
                                        required
                                        :validate="validate"
                                        v-model="nota_lancamentos.dt_vencimento_frete" />
                                </div>
                            </div>

                        </template>

                        <pre v-if="false">{{ nota_lancamentos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-submit v-if="false" @click="movimentar(nota_lancamentos, true)" color="danger">Cancelar Movimentação</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="gerar_parcelas()">Gerar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-fornecedor ref="lanc_fornec" />
        <edicao-lancamento ref="financeiro" @refresh="load()" :blockaddfornecedor="true" />
        <enquete ref="enquete" @refresh="load()" />

        <estoque-etiqueta ref="estoque_etiqueta" />

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar && item">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="item.arquivos"
                :parms="{ model_type: 'estoqueNotaFiscal', model_id: item.id_estoque_nota_fiscal }" />
        </template>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from "moment";
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import EdicaoLancamento from '../financeiro/EdicaoLancamento.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';
import EdicaoFornecedor from '../financeiro/EdicaoFornecedor.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import PrintExport from '../../shared/PrintExport.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Enquete from '../../shared/Enquete.vue';

export default {
    data() {
        return {
            inicio: this.$util.hoje(),
            fim: this.$util.hoje(),
            search: "",
            dados: null,
            montando: true,
            item: null,
            validate: false,
            canceltoken: null,
            novoItem: "",
            filtros: {
                status: "A",
                id_estoque_local: "",
                inicio: "",
                fim: "",
                semana: "",
                mes: "",
                periodo: "s",
                referencia: "",
                tipo_enquete: "", 
            },
            nota_lancamentos: null,
            ident_oc: "",
            oc: null,
            ocs: null,
            parcelas: [],
            alterando_valores: false,
            acao_anexar: false,
            filtros_busca: null, 
            files: [],
            formData: null,
            itemNF: null,
            lista_enquetes: [], 
            trocando: false, 
            comp_edicao: null,
            valor_total_informado: null, 
        }
    },

    props: ['id'],

    components: {
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzPeriodo,
        EdicaoLancamento,
        SelecaoMaterial,
        EdicaoFornecedor,
        AzFileUpload,
        EstoqueEtiqueta,
        CabecalhoGenerico,
        PrintExport,
        AzAuditLogButton, 
        Enquete, 
    },

    computed: {
        lista: function () {
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.filter (item => {
                return ( !this.search || reg.test(JSON.stringify(item)) );
            });
        },

        tem_oc: function () {
            if ( !this.item )
                return false;

            return this.item.items.find(nfi => nfi.fl_ativo && nfi.id_aquisicao_ordem_compra_item)
                ? true
                : false;
        },

        lista_ocs: function () {
            if ( !this.item )
                return false;

            return _.uniq(
                this.item.items.filter(nfi => nfi.fl_ativo && nfi.id_aquisicao_ordem_compra_item && nfi.oc_item)
                    .map(nfi => nfi.oc_item.oc ? nfi.oc_item.oc : { id_aquisicao_ordem_compra: nfi.oc_item.id_aquisicao_ordem_compra })
                    .filter(oc => oc)   
            );
        },

        lista_centros: function() {
            if ( !this.item || !this.item.id_estoque_local )
                return [];

            const locais = this.$store.state.options['estoque_locals.index'];

            if ( !locais )
                return [];

            const local = locais.find(loc => loc.id_estoque_local == this.item.id_estoque_local);

            if ( !local ) {
                return [];
            }

            const und = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == local.id_unidade_operacao);

            return und ? und.centro_custos : [];
        },

        dados_exportacao: function () { 

            return this.lista.map(item => { 
                return {
                    id: item.id_estoque_nota_fiscal,
                    tipo: item.st_tipo, 
                    serie: item.st_serie,
                    numero: item.st_numero,
                    fornecedor: item.fornecedor ? item.fornecedor.search : '',
                    emissao: this.$util.getFormatDate(item.dt_emissao),
                    entrada: this.$util.getFormatDate(item.dt_entrada),
                    valor: this.$util.formatMoeda(item.dc_valor_nota),
                    local: item.estoque_local ? item.estoque_local.search : '',
                    obs: item.st_observacoes,
                    qt_itens: item.items ? item.items.length : 0,
                    itens: item.materiais, 
                };
            });

        }
    },

    methods: {
        atualizar_valor_total () { 
            if ( !this.comp_edicao.dc_quantidade ) { 
                return; 
            }
            
            this.trocando = true; 

            this.$nextTick(() => { 
                this.comp_edicao.dc_valor_unitario = Math.round((this.valor_total_informado / this.comp_edicao.dc_quantidade) * 100000) / 100000;
                this.trocando = false; 
            });
            
            this.fechar_modal('informarValorTotalModal');
        },

        fechar_modal(modal) { 
            $('#' + modal).modal('hide');
        },  
        
        informar_valor_total (comp) { 
            this.comp_edicao = null; 

            this.$nextTick(() => { 
                this.comp_edicao = comp;
                this.valor_total_informado = 0; 
                $('#informarValorTotalModal').modal('show');
            });
        },

        imprimir_espelho() { 
            this.$util.htmlToPaper('espelho-nota', null, () => {
                console.log("Printing");
            });
        },
        
        toggle_itens_oc (oc) { 
            let selecao = oc.items.find(item => item.qtde_pendente > 0 && !item.preco.selec) ? true : false;

            oc.items.forEach(oci => { 
                if ( oci.qtde_pendente > 0 ) { 
                    oci.preco.selec = selecao; 
                }
            });
        },

        preencher_enquente(nota) { 
            this.$refs.enquete.abrir(nota, 'App\\azure\\estoqueNotaFiscal', 'id_estoque_nota_fiscal');
        },

        set_barcode (comp) { 
            comp.add_barcode = true;
        },

        tem_item_com_estoque_lote(item) {
            return item.items && item.items.find(nfi => nfi.fl_ativo && nfi.id_estoque_item)
                ? true
                : false;
        },

        emitir_etiqueta(item) {
            const etiquetaItens = item.items
                .filter(nfi => nfi.fl_ativo && nfi.id_estoque_item)
                .map(lote => {
                    return {
                        checked: false,
                        id_estoque_item: lote.item.id_estoque_item,
                        lote: (lote.item && lote.item.fl_controla_lote) ? lote.st_lote : null,
                        validade: (lote.item && lote.item.fl_controla_lote) ? lote.dt_validade : null,
                        qtde: lote.dc_quantidade,
                        search:  lote.item.search,
                    }
                });

            this.$refs.estoque_etiqueta.show(etiquetaItens);
        },

        abrir_anexar_arquivo (item) {

            this.item = item;

            if ( this.item.arquivos && this.item.arquivos.length && !this.item.arquivos.find(arq => arq.arquivo) ) {

                this.item.carregando = true;

                this.carregar_arquivos(true);

            } else {

                this.acao_anexar = true;

                this.$nextTick(() => {
                    this.$refs.upload.abrir();
                });

            }

        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'estoque_nota_fiscals',
                func: 'show',
                parms: {
                    id: this.item.id_estoque_nota_fiscal,
                    with: [
                        'arquivos.arquivo',
                    ]
                },
            })
            .then(res => {
                this.item.arquivos = res.arquivos;
                this.acao_anexar = true;

                if ( abrir ) {
                    this.$nextTick(() => {
                        this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.item.carregando = false;
                this.$store.commit('loading', false);
            });

        },

        gerar_parcelas() {
            if ( Math.round(parseFloat(this.nota_lancamentos.valor_sem_frete) * 100) !=
                Math.round(parseFloat(this.total_lista(this.parcelas, "dc_valor")) * 100) ) {

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Valor das parcelas não confere com o valor da nota: "
                        + this.$util.formatMoeda(this.nota_lancamentos.valor_sem_frete)
                        + ' vs '
                        + this.$util.formatMoeda(this.total_lista(this.parcelas, "dc_valor")),
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, {
                service: 'estoque',
                func: 'gerar_lancamentos',
                dados: {
                    ...this.nota_lancamentos,
                    parcelas: this.parcelas,
                },
                modal: 'incluirLancamentosModal',
                toast: true,
                reload: true,
            });
        },

        imprimir_oc(id) {
            this.$util.print_preview('imprimir/oc/' + id, true);
        },

        adicionar_lote(material, index) {
            let item = _.cloneDeep(material);

            item.id_estoque_nota_fiscal_item = null;
            item.st_lote = "";
            item.dt_validade = "";
            item.dc_quantidade = "";

            this.trocando = true;

            this.$nextTick(() => { 
                this.item.items.splice(index + 1, 0, item);
                this.trocando = false;
            });
        },

        remover_item(item) {
            if ( !confirm('Confirma remover o item?') ) {
                return;
            }

            this.trocando = true; 

            this.$nextTick(() => { 
                item.fl_ativo = false;
                this.trocando = false;
            });
        },

        incluir_oc() {
            let lista = this.oc.items.filter(item => item.preco.selec);

            if ( this.oc.id_fornecedor != this.item.id_fornecedor 
                && this.oc.forn_nf 
                && this.oc.fornecedor 
                && this.oc.forn_nf.st_cpf_cnpj 
                && this.oc.fornecedor.st_cpf_cnpj 
                && this.oc.forn_nf.st_cpf_cnpj.substr(0,8) == this.oc.fornecedor.st_cpf_cnpj.substr(0,8) ) { 
                    
                this.$toast.add({
                    severity: "info",
                    summary: "Atenção",
                    detail: "OC de filial: " + this.oc.fornecedor.search,
                    life: 3000
                });

            } else if ( this.item.id_fornecedor != this.oc.id_fornecedor) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Fornecedor inválido da OC: " + this.oc.fornecedor.search,
                    life: 3000
                });
                return;
            }

            lista.forEach(element => {

                let qtd;
                let qtd_compra;

                if ( element.preco.item.estoque_item.st_unidade_compra
                    && element.preco.item.estoque_item.st_unidade_compra != element.preco.item.estoque_item.st_unidade_estoque ) {

                    qtd_compra = element.preco.dc_quantidade;
                    qtd = element.preco.item.in_fator;

                } else {

                    qtd_compra = null;
                    qtd = element.preco.dc_quantidade;

                }

                this.incluir_item({
                    quantidade: Math.round(qtd),
                    quantidade_compra: Math.round(qtd_compra),
                    preco: element.preco.dc_preco,
                    id_aquisicao_ordem_compra_item: element.id_aquisicao_ordem_compra_item,
                    ...element.preco.item.estoque_item,
                    oc_item: element,
                });
            });

            this.oc = null;
        },

        buscar_oc() {
            if ( !this.item.id_fornecedor ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione o fornecedor desejado.",
                    life: 3000
                });
                return;
            }


            if ( this.ident_oc && isNaN(this.ident_oc) ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Informe o número da OC. " + this.ident_oc,
                    life: 3000
                });
                return;
            }

            if ( this.ident_oc ) {

                this.$util.load(this, {
                    service: 'aquisicao_ocs',
                    func: 'show',
                    parms: {
                        id_fornecedor: this.item.id_fornecedor,
                        id: this.ident_oc,
                        nf: true, 
                    },
                    loadTo: res => {
                        if ( !res ) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "OC não identificada: " + this.ident_oc,
                                life: 3000
                            });
                            return;
                        }

                        if ( res.id_fornecedor != this.item.id_fornecedor 
                            && res.forn_nf 
                            && res.fornecedor 
                            && res.forn_nf.st_cpf_cnpj 
                            && res.fornecedor.st_cpf_cnpj 
                            && res.forn_nf.st_cpf_cnpj.substr(0,8) == res.fornecedor.st_cpf_cnpj.substr(0,8) ) { 
                                
                            this.$toast.add({
                                severity: "info",
                                summary: "Atenção",
                                detail: "OC de filial: " + res.fornecedor.search,
                                life: 3000
                            });

                        } else { 

                            if ( res.id_fornecedor != this.item.id_fornecedor ) {
                                this.$toast.add({
                                    severity: "error",
                                    summary: "Atenção",
                                    detail: "Fornecedor inválido: " + res.fornecedor.search,
                                    life: 3000
                                });
                                return;
                            }

                        }

                        if ( !res.fl_autorizado ) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "Ordem de compra " + ( res.fl_autorizado === null ? 'aguardando autorização.' : 'não autorizada.'),
                                life: 3000
                            });
                            return;
                        }

                        this.oc = res;
                    }
                });

            } else {

                // aquisicao_ordem_compras.index

                this.$util.load(this, {
                    service: 'aquisicao_ordem_compras',
                    func: 'index',
                    parms: {
                        id_fornecedor: this.item.id_fornecedor,
                        nota: true,
                    },
                    loadTo: res => {
                        this.ocs = res;
                    }
                });

            }
        },

        incluir_fornecedor() {
            if ( !confirm('Incluir Fornecedor?') )
                return;

            this.$refs.lanc_fornec.incluir();
        },

        abrir_lancamentos (nota) {
            this.nota_lancamentos = _.cloneDeep(nota);

            $('#lancamentosModal').modal('show');
        },

        editar_lancamento(lancamento) {
            this.$refs.financeiro.editar(lancamento);
        },

        incluir_parcela() {

            this.alterando_valores = true;

            let valor = 0;
            let vencimento = this.$util.hoje();

            vencimento = _.last(this.parcelas).dt_vencimento;
            vencimento = moment(vencimento, "YYYY-MM-DD").add(1,"month").format('YYYY-MM-DD');

            if ( !this.nota_lancamentos.condicoes ) {
                valor = Math.round((this.nota_lancamentos.valor_sem_frete / ( this.parcelas.length + 1 )) * 100) / 100;

                this.parcelas.forEach(parcela => {
                    parcela.dc_valor = valor;
                    parcela.valor_total = valor;
                });

                valor = valor + ( parseFloat(this.nota_lancamentos.valor_sem_frete) - ( valor * ( this.parcelas.length + 1 ) ) );
            }

            this.parcelas.push({
                id_fornecedor: this.nota_lancamentos.id_fornecedor,
                dc_valor: valor,
                st_doc: this.nota_lancamentos.st_serie + '.' + this.nota_lancamentos.st_numero,
                id_unidade_operacao: this.nota_lancamentos.estoque_local.id_unidade_operacao,
                id_estoque_nota_fiscal: this.nota_lancamentos.id_estoque_nota_fiscal,
                st_descricao: 'Nota Fiscal',
                valor_total: valor,
                dt_vencimento: vencimento,
            });

            this.nota_lancamentos.parcelas ++;

            this.$nextTick(() => {
                this.alterando_valores = false;
            });

        },

        remover_parcela() {
            if ( this.parcelas.length > 1 ) {

                if ( !this.nota_lancamentos.condicoes ) {
                    this.alterando_valores = true;

                    let valor = 0;

                    valor = Math.round((this.nota_lancamentos.valor_sem_frete / ( this.parcelas.length - 1 )) * 100) / 100;

                    this.parcelas.forEach(parcela => {
                        parcela.dc_valor = valor;
                        parcela.valor_total = valor;
                    });

                    valor = valor + ( parseFloat(this.nota_lancamentos.valor_sem_frete) - ( valor * ( this.parcelas.length - 1 ) ) );

                    this.parcelas[this.parcelas.length - 2].dc_valor = valor;
                    this.parcelas[this.parcelas.length - 2].valor_total = valor;

                    this.$nextTick(() => {
                        this.alterando_valores = false;
                    });
                }

                this.parcelas.splice(this.parcelas.length - 1, 1);
                this.nota_lancamentos.parcelas --;
            }
        },

        financeiro (nota) {

            this.nota_lancamentos = null;
            this.validate = false;

            this.$nextTick(() => {

                let condicoes = nota.items.find(nfi => nfi.fl_ativo && nfi.oc_item && nfi.oc_item.oc.js_condicoes_pagamento);

                this.nota_lancamentos = _.cloneDeep(nota);
                this.nota_lancamentos.parcelas = [];
                this.nota_lancamentos.condicoes = null;
                this.nota_lancamentos.mult_categ = false;
                this.parcelas = [];

                if ( condicoes && condicoes.oc_item.oc.js_condicoes_pagamento.parcelas.length > 0 ) {

                    this.nota_lancamentos.parcelas = condicoes.oc_item.oc.js_condicoes_pagamento.parcelas.length;
                    this.nota_lancamentos.condicoes = condicoes.oc_item.oc.js_condicoes_pagamento;

                    condicoes.oc_item.oc.js_condicoes_pagamento.parcelas.forEach(parcela => {

                        let valor = 0;
                        let vencimento = this.$util.hoje();

                        // Valor das Parcela...

                        if ( parcela.modo_valor == 'V' ) {
                            valor = parcela.valor;
                        } else if ( parcela.valor > 0 ) {
                            valor = Math.round(parseFloat(nota.valor_sem_frete) * parseFloat(parcela.valor) ) / 100;
                        } else if ( this.nota_lancamentos.parcelas > 0 ) {
                            valor = Math.round((parseFloat(nota.valor_sem_frete) / this.nota_lancamentos.parcelas) * 100) / 100;
                        }

                        // Vencimento da Parcela...

                        if ( parcela.regra == 'P' ) {
                            if ( parcela.modo_tempo == 'D' ) {
                                vencimento = parcela.tempo_data;
                            } else if ( parcela.tempo_dias > 0 ) {
                                if ( parcela.tempo_dias % 30 == 0 ) {
                                    vencimento = moment(vencimento, "YYYY-MM-DD").add(parcela.tempo_dias/30,"month").format('YYYY-MM-DD');
                                } else {
                                    vencimento = moment(vencimento, "YYYY-MM-DD").add(parcela.tempo_dias,"day").format('YYYY-MM-DD');
                                }
                            }
                        }

                        // Inclusão da Parcela...

                        this.parcelas.push({
                            id_fornecedor: nota.id_fornecedor,
                            dc_valor: valor,
                            st_doc: nota.st_serie + '.' + nota.st_numero,
                            id_unidade_operacao: nota.estoque_local.id_unidade_operacao,
                            id_estoque_nota_fiscal: nota.id_estoque_nota_fiscal,
                            st_descricao: 'Nota Fiscal',
                            valor_total: valor,
                            dt_vencimento: vencimento,
                        });
                    })

                } else {

                    this.nota_lancamentos.parcelas = 1;

                    this.parcelas.push({
                        id_fornecedor: nota.id_fornecedor,
                        dc_valor: nota.valor_sem_frete,
                        st_doc: nota.st_serie + '.' + nota.st_numero,
                        id_unidade_operacao: nota.estoque_local.id_unidade_operacao,
                        id_estoque_nota_fiscal: nota.id_estoque_nota_fiscal,
                        st_descricao: 'Nota Fiscal',
                        valor_total: nota.valor_sem_frete,
                        dt_vencimento: this.$util.hoje(),
                    });

                }

                // Categoria...

                const categs = _.uniq(
                    nota.items.filter(item => _.get(item, 'item.grupo.id_categoria'))
                        .map(item => _.get(item, 'item.grupo.categoria.search'))
                );

                if ( categs && categs.length > 1 ) {

                    this.nota_lancamentos.id_categoria = null;
                    this.nota_lancamentos.mult_categ = true;
                    this.nota_lancamentos.categs = categs.join(', ');

                } else {

                    const primeiro = _.first(nota.items);

                    if ( primeiro ) {
                        this.nota_lancamentos.id_categoria = _.get(primeiro, 'item.grupo.id_categoria');
                    }

                }

                $('#incluirLancamentosModal').modal('show');

            });

        },

        totalizar_items(nota) {
            return this.lista_items(nota).reduce((total, carry) => total
                + ( parseFloat(carry.dc_quantidade) * parseFloat(carry.dc_valor_unitario) )
                + ( parseFloat(carry.dc_valor_ipi) ), 0);
        },

        total_lista(lista, campo) {
            return _.sumBy(lista, campo);
        },

        lista_items (nota) {
            return nota.items.filter(item => item.fl_ativo);
        },

        editar(nota) {
            this.item = null;
            this.oc = null;
            this.ocs = null;
            this.ident_oc = null;
            this.validate = false;

            this.$nextTick(() => {
                $('#notaFiscalEstoqueModal').modal('show');

                this.$util.load(this, {
                    service: 'estoque_nota_fiscals',
                    func: 'show',
                    parms: {
                        id: nota.id_estoque_nota_fiscal,
                    },
                    loadTo: res => {
                        this.item = res;
                    },
                    final: () => {
                        if ( !this.item ) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "Nota não encontrada.",
                                life: 3000
                            });

                            $('#notaFiscalEstoqueModal').modal('hide');
                        }
                    }
                });

                // this.item = _.cloneDeep(nota);
            });
        },

        atualizar() {
            this.$util.atualizar(this, {
                service: 'estoque_nota_fiscals',
                dados: {
                    ...this.item,
                },
                modal: 'notaFiscalEstoqueModal',
                reload: true,
            });
        },

        cancelar_nota(nota) {
            if ( !confirm ('Confirma cancelar a nota fiscal?') )
                return;

            this.$util.toggle(this, {
                service: 'estoque_nota_fiscals',
                dados: {
                    id_estoque_nota_fiscal: nota.id_estoque_nota_fiscal,
                    fl_ativo: false,
                },
                callback: () => {
                    $('.modal').modal('hide');
                    this.load();
                }
            });
        },

        movimentar(nota, cancelar = false) {
            if ( this.$store.state.loading ) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Em processamento. Tente novamente.",
                    life: 3000
                });
                return;
            }

            if ( cancelar ) {
                if ( !confirm ('Confirma realizar o cancelamento da movimentação da nota fiscal?') )
                    return;
            } else {
                if ( !confirm ('Confirma realizar a movimentação da nota fiscal?') )
                    return;
            }

            this.$util.atualizar(this, {
                service: 'estoque',
                func: 'movimentar_nota_fiscal',
                dados: {
                    id_estoque_nota_fiscal: nota.id_estoque_nota_fiscal,
                    cancelar: cancelar,
                },
                toast: true,
                modal: 'notaFiscalEstoqueModal',
                reload: true,
            });
        },

        incluir_item (novo) {
            if ( !novo )
                return;

            let qtd;
            let fator;
            //let unidade;

            if ( novo.st_unidade_compra && novo.st_unidade_compra != novo.st_unidade_estoque ) {
                qtd = novo.quantidade_compra;
                fator = novo.quantidade;
                //unidade = novo.st_unidade_compra;
            } else {
                qtd = novo.quantidade;
                fator = 1;
                //unidade = novo.st_unidade_estoque;
            }

            this.item.items.push({
                id_estoque_item: novo.id_estoque_item,
                id_estoque_nota_fiscal_item: null, 
                item: novo,
                dc_quantidade: qtd ? qtd : 1,
                in_fator: fator ? fator : 1,
                dc_valor_unitario: novo.preco ? novo.preco : 0,
                dc_valor_ipi: 0,
                st_observacoes: "",
                fl_ativo: true,
                st_lote: _.get(novo, 'lote.numero'),
                dt_validade: _.get(novo, 'lote.validade'),
                id_aquisicao_ordem_compra_item: novo.id_aquisicao_ordem_compra_item,
                oc_item: novo.oc_item,
                add_barcode: false, 
                barcode: "",
                obs: false,
                st_marca: "",
            });
        },

        atualizarDePara() {
            // atualizar de para antes de abrir a tela

            let deParaStore = [];
            let itemsToRemove = [];
            for (let index = 0; index < this.itemNF.items.length; index++) {
                if(this.itemNF.items[index].item) {
                    this.itemNF.items[index].id_estoque_item = _.get(this.itemNF.items[index], 'item.id_estoque_item');
                    deParaStore.push({
                        id_fornecedor: _.get(this.itemNF.items[index], 'deParaItem.id_fornecedor'),
                        id_estoque_item: _.get(this.itemNF.items[index], 'item.id_estoque_item'),
                        st_codigo: _.get(this.itemNF.items[index], 'deParaItem.st_codigo'),
                        st_ncm: _.get(this.itemNF.items[index], 'deParaItem.st_ncm'),
                    });
                } else {
                    itemsToRemove.push(index);
                }
            }

            for (let i = itemsToRemove.length - 1; i >= 0; i--) {
                let index = itemsToRemove[i];
                this.itemNF.items.splice(index, 1);
            }

            $('#notaFiscalDeParaModal').modal('hide');

            this.$util.atualizar(this, {
                service: 'fornecedor_estoque_item',
                func: 'atualizar_depara_nf',
                dados: {
                    items: [...deParaStore],
                },
                modal: 'notaFiscalDeParaModal',
                callback: (res) => {
                    if(res && res.status_code && res.status_code != 200) {
                        this.$toast.add({
                            severity: "warn",
                            summary: "Atenção",
                            detail: res.msg ? res.msg : 'Erro ao atualizar "De Para"',
                            life: 3000
                        });
                        return;
                    }

                    this.incluir(this.itemNF);
                }
            });

            // this.incluir(this.itemNF);
        },
        
        azUpload(file) {
            this.$store.commit("loading", true);

            this.itemNF = null;
            this.item = null;

            this.formData = undefined;
            this.formData = new FormData();

            this.formData.append("file", file.file);
            this.formData.append('id_estoque_local', this.filtros.id_estoque_local);

            return this.axios
                .post("/suprimentos_importar_nf", this.formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(res => {
                    if(res.data) {
                        this.itemNF = res.data;
                        $('#notaFiscalDeParaModal').modal('show');
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },

        /**
         * Pretreatment
         * @param  Object|undefined   newFile   Read and write
         * @param  Object|undefined   oldFile   Read only
         * @param  Function           prevent   Prevent changing
         * @return undefined
         */
        inputFilter: function(newFile, oldFile, prevent) {
          if (newFile && !oldFile) {
            // Filter non-image file
            if (!/\.(xml)$/i.test(newFile.name)) {
              return prevent();
            }
          }

          // Create a blob field
          newFile.blob = "";
          let URL = window.URL || window.webkitURL;
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file);
          }
        },

        /**
         * Has changed
         * @param  Object|undefined   newFile   Read only
         * @param  Object|undefined   oldFile   Read only
         * @return undefined
         */
        inputFile: function(newFile, oldFile) {
          if (newFile && oldFile && !newFile.active && oldFile.active) {
            // Get response data
            if (newFile.xhr) {
              //  Get the response status code
            }
          }

          this.$refs.upload.active = true;
        },

        incluir(nf = null) {
            this.oc = null;
            this.ocs = null;
            this.ident_oc = null;
            this.validate = false;
            this.item = null;

            this.$nextTick(() => {
                if (nf) {
                    this.item = { ...nf };
                } else {
                    this.item = {
                        id_estoque_nota_fiscal: null,
                        id_estoque_local: this.filtros.id_estoque_local,
                        dt_emissao: null,
                        dt_entrada: this.$util.hoje(),
                        st_frete_tipo: "",
                        st_tipo: "", 
                        fl_ativo: true,
                        fl_processada: false,
                        fl_aplicacao_direta: false,
                        fl_consig: false, 
                        id_centro_custo: "",
                        dc_valor_nota: 0,
                        dc_valor_desconto: 0,
                        items: [],
                    };
                }

                $('#notaFiscalEstoqueModal').modal('show');
            });
        },

        load() {
            if ( this.montando )
                return;

            this.$util.setCookie('estoque-armazem', this.filtros.id_estoque_local);

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.filtros_busca = _.cloneDeep(this.filtros);

            this.$util.load(this, {
                service: 'estoque_nota_fiscals',
                func: 'index',
                canceltoken: this.canceltoken.token,
                parms: {
                    ...this.filtros,
                    search: this.search, 
                    lancamento: true,
                }
            });
        },

    },

    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },

    beforeMount() {
        this.filtros.id_estoque_local = this.$util.getCookie('estoque-armazem') ? this.$util.getCookie('estoque-armazem') : "";
    },

    mounted () {
        this.montando = false;

        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Compra", path: "/suprimentos/compra" }
        ]);

        this.$util.loadItem(this, { 
            service: 'enquetes',
            func: 'index', 
            parms: { 
                where: { 
                    model_type: 'App\\azure\\estoqueNotaFiscal', 
                    fl_ativo: 1, 
                }
            }
        })
        .then(res => { 
            this.lista_enquetes = res;
        });

        this.$nextTick(() => {
            this.load();
        });

        if ( this.$route.params.id ) {
            this.editar({ id_estoque_nota_fiscal: this.$route.params.id });
        }
    }

}
</script>

<style scoped>
.modal-dialog-cheio {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
  min-height: 98% !important;
}

.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>
